module.exports = __webpack_public_path__ + "static/media/SPADE.ff4a8c75.png";